import { Modal, Button, Icon } from "@conuti-das/prince-ui";
import { Flex, princeIcon } from "@/ui-prince";
import { MappingTestTab } from "./MappingTestTab";

export function TestPanel({
  open, onClose, bundleId, messageType,
}: {
  open: boolean;
  onClose: () => void;
  bundleId: string;
  messageType: string;
}) {
  return (
    <Modal
      isOpen={open}
      onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}
      title={`Mapping testen — ${messageType}`}
      className="prn-dialog-wide"
    >
      <Flex justifyContent="End" style={{ marginBottom: "var(--s-2)" }}>
        <Button variant="plain" onPress={onClose}>
          <Icon name={princeIcon("decline")} size={16} />
          Schließen
        </Button>
      </Flex>
      {open && <MappingTestTab bundleId={bundleId} msgType={messageType} />}
    </Modal>
  );
}
